<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-card class="elevation-2 animated fadeIn">
          <v-toolbar flat>
            <v-toolbar-title>Comunicaciones Oficiales</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-treeview
              v-model="tree"
              :open="open"
              :items="items"
              hoverable
              selected-color="red"
              return-object
              activatable
              @update:active="onUpdate"
              expand-icon="expand_more"
              on-icon="picture_as_pdf"
              off-icon="picture_as_pdf"
              indeterminate-icon="picture_as_pdf"
              item-key="name"
              open-on-click
              class="caption font-weight-thin"
            >
            </v-treeview>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
    import script from './script'
    export default script
</script>


// WEBPACK FOOTER //
// src/components/documentos/index/component.vue